module.exports = __webpack_public_path__ + "static/media/h-2-02.bbc1807e.jpg";